import { Button, Collapse, Link, Stack } from "@mui/material";
import React, { useState } from "react";
import ReplyIcon from "@mui/icons-material/Reply";
import ActivityComment from "./activity-comment";
import { ActivityMappedData } from "../activity";
import { CommentWrapper } from "../ActivityMainFrame/activity-main-frame";
import CommentForm from "../../Misc/CommentForm/comment-form";
import { UserHasAcl } from "../../../Utils/helpers";
import { AclTypes } from "../../../Core/Api/Types/acl-types";
import { useTranslation } from "react-i18next";

interface ActivityCommentFeedProps {
  parentActivityId: number;
  activities: ActivityMappedData[];
  myUserId: number;
  handleCommentSend?: (text: string, mainActivityId: number) => void;
}
export const ActivityCommentFeed: React.FC<ActivityCommentFeedProps> = (props) => {
  const { t } = useTranslation();
  const limit = 2;
  const needExtend = props.activities.length > limit;
  const [isExpanded, setIsExpanded] = React.useState(false);
  const croppedList = needExtend ? [...props.activities].slice(0, limit) : props.activities;
  const extendList = needExtend ? [...props.activities].splice(limit) : [];

  const [isReplying, setIsReplying] = useState(false);

  const handleExpandClick = () => {
    setIsExpanded((prevState) => !prevState);
  };

  return (
    <>
      <Stack spacing={0.5}>
        {croppedList.map((activity) => (
          <ActivityComment
            author={activity.userName}
            date={activity.activityDate}
            type="conversation"
            isReply={props.myUserId !== activity.userId}
            key={activity.id}
          >
            {activity.activityDetails}
          </ActivityComment>
        ))}
        <Collapse in={isExpanded}>
          <Stack spacing={0.5}>
            {extendList.map((activity) => (
              <ActivityComment
                author={activity.userName}
                date={activity.activityDate}
                type="conversation"
                isReply={props.myUserId !== activity.userId}
                key={activity.id}
              >
                {activity.activityDetails}
              </ActivityComment>
            ))}
          </Stack>
        </Collapse>
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1.5 }}>
        {needExtend && (
          <Link underline="hover" color="primary.text" component="button" onClick={handleExpandClick}>
            {isExpanded ? t("button:hideDiscussion") : t("button:showDiscussion", { count: props.activities.length })}
          </Link>
        )}
        <Button size="small" startIcon={<ReplyIcon />} onClick={() => setIsReplying((prev) => !prev)}>
          {t("common:reply")}
        </Button>
      </Stack>
      {isReplying && UserHasAcl(AclTypes.aclActivityAdd) && (
        <CommentWrapper>
          <CommentForm
            onSend={(text) => {
              if (props.handleCommentSend) {
                props.handleCommentSend(text, props.parentActivityId);
                setIsReplying(false);
              }
            }}
            sx={{ mt: 2 }}
          />
        </CommentWrapper>
      )}
    </>
  );
};

export default ActivityCommentFeed;
